import React from 'react';

import ContentWrapper, { ContentWrapperProps } from '../ContentWrapper';

import {
  CardContainer, Content,
} from './index.styles';

export interface ContentCardProps extends ContentWrapperProps {
  children: React.ReactElement | React.ReactElement[],
  variant?: 'contained' | 'outlined' | 'transparent',
  padding?: 'none' | 'small' | 'medium' | 'large',
  maxWidth?: number,
  fillHeight?: boolean,
}

const ContentCard = ({ children, variant = 'contained', padding = 'medium', maxWidth, fillHeight, ...rest }: ContentCardProps) => (
  <CardContainer
    $variant={variant}
    $padding={padding}
    $maxWidth={maxWidth}
    $fillHeight={fillHeight}
  >
    <ContentWrapper {...rest} dense>
      <Content>
        {children}
      </Content>
    </ContentWrapper>
  </CardContainer>
);

export default ContentCard;
